import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as innovationAsset from '../innovation-asset'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: innovationAsset.RESOURCE.payload.dimension.partialId,
      partialId: innovationAsset.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The approval status of the innovation asset',
    isOptional: true,
    name: 'Approval Status',
    partialId: PartialId.Standard.create('approval_status'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
